angular.module('homebot.directives')

  .directive('nightlyRentalsSection', ['APP_CONFIG', 'DataService', 'RollbarService', 'UtilService', '$window', function(APP_CONFIG, DataService, RollbarService, utils, $window){
    return {
      restrict: 'A',
      controllerAs: 'nightlyCtrl',
      bindToController: {
        agent: '=',
        loans: '=',
        home: '=',
        userId: '@',
      },
      scope: {},
      templateUrl: '/homes/templates/section-nightly-rentals.html',

      controller: function(){
        let ctrl = this;

        if(APP_CONFIG.FEATURE_AIRDNA !== 1){
          ctrl.viewState = 'staticFallback';
          return;
        }

        let args = {
          address: ctrl.home.address.street,
          bedrooms: ctrl.home.bedrooms,
          bathrooms: ctrl.home.bathrooms,
          accommodates: ctrl.home.bedrooms * 1 || 2,
          zipcode: ctrl.home.address.zip,
        };

        function showLoading(){
          ctrl.viewState = 'loading';
        }

        function useStaticFallback(){
          ctrl.viewState = 'staticFallback';
        }

        showLoading();

        ctrl.loadAirDna = function(callback) {
          return DataService.getRentalPotential(ctrl.home.id, args)
            .then((result) => {
              if(!result){
                useStaticFallback();
                return;
              }

              if(!result.property_stats || result.error){
                RollbarService.error('Bad AirDNA response', Object.assign({homeId: ctrl.home.id}, {result: result}));
                useStaticFallback();
                return;
              }

              ctrl.viewState = 'airdna';
              ctrl.potential = result.property_stats;

              utils.track('AirDNALoaded');
            })
            .catch(() => {
              useStaticFallback();
            });
        }

        ctrl.toggleDrawer = function(){
          ctrl.drawerOpen = !ctrl.drawerOpen;
        }
      },
      link: function($scope, el, attrs, ctrl){
        function isInViewport(elem) {
          var bounding = elem.getBoundingClientRect();
          var padding = 150; // number of pixels above this element that should trigger a load

          return (
            bounding.top >= 0 &&
            bounding.top <= ($window.innerHeight + padding || document.documentElement.clientHeight + padding)
          )
        }

        var scrollHandler = _.throttle(() => {
          if (el && el[0] && isInViewport(el[0])) {
            ctrl.loadAirDna()
            $($window).off('scroll.airdnaScroll', scrollHandler);
          }
        }, 250);

        $($window).on('scroll.airdnaScroll', scrollHandler);
      }
    }

  }]);
